<div class="ia-chat-modal-backdrop" [class.closing]="closing()">
<div class="ia-chat-modal-shell">
<section class="ia-chat-modal">
    <header class="chat-header">
        <button class="icon-button" type="button" (click)="requestClose()" [attr.aria-label]="'common.close' | translate">
            <ra-icon icon="arrow-left" varColor="contentSecondary" [size]="20" />
        </button>
        <ra-chat-orb [size]="30" />
        <div class="assistant-title">
            <strong>{{ 'iaChat.assistantTitle' | translate }}</strong>
        </div>

        <div class="header-actions">
            <button class="icon-button" type="button" (click)="requestClose()" [attr.aria-label]="'common.close' | translate">
                <ra-icon icon="close-square" varColor="contentSecondary" [size]="20" />
            </button>
        </div>
    </header>

    <ra-chat-message-list>
        @for (message of store.messages(); track message.id) {
            @if (message.type === 'typeSelection') {
                <div class="message-row ia">
                    <div class="type-selector">
                        <button type="button" class="type-card normal" (click)="store.selectType(documentTypeEnum.NORMAL)">
                            <span class="type-card__icon">
                                <ra-icon icon="document-normal" varColor="primary" [size]="18" />
                            </span>
                            <span class="type-card__content">
                                <strong>{{ 'iaChat.typeDocumentTitle' | translate }}</strong>
                                <span>{{ 'iaChat.typeDocumentSubtitle' | translate }}</span>
                            </span>
                            <span class="type-card__chevron" aria-hidden="true"></span>
                        </button>
                        <button type="button" class="type-card quote" (click)="store.selectType(documentTypeEnum.QUOTE)">
                            <span class="type-card__icon">
                                <ra-icon icon="dollar-circle" varColor="accentOrange" [size]="18" />
                            </span>
                            <span class="type-card__content">
                                <strong>{{ 'iaChat.typeQuoteTitle' | translate }}</strong>
                                <span>{{ 'iaChat.typeQuoteSubtitle' | translate }}</span>
                            </span>
                            <span class="type-card__chevron" aria-hidden="true"></span>
                        </button>
                        <button type="button" class="type-card contract" (click)="store.selectType(documentTypeEnum.CONTRACT)">
                            <span class="type-card__icon">
                                <ra-icon icon="pen-draw" varColor="accentGreen" [size]="18" />
                            </span>
                            <span class="type-card__content">
                                <strong>{{ 'iaChat.typeContractTitle' | translate }}</strong>
                                <span>{{ 'iaChat.typeContractSubtitle' | translate }}</span>
                            </span>
                            <span class="type-card__chevron" aria-hidden="true"></span>
                        </button>
                    </div>
                </div>
            } @else if (message.type === 'quickReply') {
                <!-- Respondidos (por clique ou por escrito), os botões somem — como o
                     seletor de tipo, que também não fica reclicável no histórico. -->
                @if (!message.answered) {
                    <div class="message-row user quick-reply">
                        @for (option of store.quickReplyOptionsOf(message); track option.value) {
                            <button type="button" class="quick-reply__chip" (click)="store.answerQuickReply(message, option.value)">
                                {{ option.label }}
                            </button>
                        }
                    </div>
                }
            } @else {
                <ra-chat-bubble [sender]="message.sender === 'user' ? 'user' : 'assistant'">
                    @if (message.type === 'text' || message.type === 'favoriteField') {
                        <!-- Fala da IA "digita" (typewriter); a do usuário aparece inteira. -->
                        @if (message.sender !== 'user') {
                            <ia-chat-typewriter
                                [text]="message.translationKey
                                    ? (message.translationKey | translate: message.translationParams)
                                    : (message.text ?? '')" />
                        } @else if (message.translationKey) {
                            <p>{{ message.translationKey | translate: message.translationParams }}</p>
                        } @else {
                            <p>{{ message.text }}</p>
                        }
                    }
                    @if (message.type === 'favoriteField') {
                        <small>{{ 'iaChat.favoriteField' | translate }}</small>
                    }
                    @if (message.type === 'image') {
                        <img
                            class="media-clickable"
                            [src]="message.mediaUrls[0] || message.mediaPaths[0]"
                            (click)="openViewer(message, 0)" />
                    }
                    @if (message.type === 'groupImage') {
                        <!-- No máximo 4 miniaturas; o excedente vira "+N" na última.
                             Clique abre o visualizador fullscreen com TODAS. -->
                        <div class="image-grid">
                            @for (path of visibleMedia(message); track path; let index = $index) {
                                <button type="button" class="image-grid__tile" (click)="openViewer(message, index)">
                                    <img [src]="path" />
                                    @if (index === 3 && hiddenMediaCount(message) > 0) {
                                        <span class="image-grid__more">+{{ hiddenMediaCount(message) }}</span>
                                    }
                                </button>
                            }
                        </div>
                    }
                    @if (message.type === 'video') {
                        <video [src]="message.mediaUrls[0] || message.mediaPaths[0]" controls></video>
                    }
                    @if (message.uploadStatus === 'uploading') {
                        <div class="upload-status">{{ 'iaChat.uploading' | translate }} {{ message.uploadProgress || 0 }}%</div>
                    }
                    @if (message.uploadStatus === 'error') {
                        <div class="upload-status error">{{ 'iaChat.uploadFailed' | translate }}</div>
                    }
                </ra-chat-bubble>
            }
        }

        @if (store.isTyping()) {
            <ra-chat-bubble sender="assistant"><ra-chat-typing /></ra-chat-bubble>
        }
    </ra-chat-message-list>

    <footer class="chat-input" [class.locked]="store.inputLocked()">
        <ra-chat-composer
            [value]="store.draft()"
            (valueChange)="store.setDraft($event)"
            [disabled]="store.inputLocked()"
            [placeholder]="(store.inputLocked() ? 'iaChat.chooseTypeHint' : 'iaChat.messageHint') | translate"
            [hint]="'iaChat.enterToSend' | translate"
            [sendLabel]="'iaChat.send' | translate"
            (send)="sendDraft()">
            <button
                raChatComposerStart
                class="attach-toggle"
                type="button"
                [disabled]="store.inputLocked()"
                [class.open]="store.showAttachMenu()"
                [attr.aria-label]="'iaChat.attachMedia' | translate"
                (click)="$event.stopPropagation(); store.showAttachMenu.set(!store.showAttachMenu())">
                <ra-icon icon="add" varColor="currentColor" [size]="20" />
            </button>
        </ra-chat-composer>
    </footer>

    @if (viewer(); as media) {
        <div class="media-viewer" (click)="closeViewer()">
            <button
                class="media-viewer__close"
                type="button"
                (click)="closeViewer()"
                [attr.aria-label]="'common.close' | translate">
                <ra-icon icon="close-square" varColor="currentColor" [size]="24" />
            </button>

            @if (media.urls.length > 1) {
                <button class="media-viewer__nav prev" type="button" (click)="$event.stopPropagation(); stepViewer(-1)">
                    <ra-icon icon="arrow-left" varColor="currentColor" [size]="24" />
                </button>
            }

            <img [src]="media.urls[media.index]" (click)="$event.stopPropagation()" />

            @if (media.urls.length > 1) {
                <button class="media-viewer__nav next" type="button" (click)="$event.stopPropagation(); stepViewer(1)">
                    <ra-icon icon="arrow-right" varColor="currentColor" [size]="24" />
                </button>
                <span class="media-viewer__counter">{{ media.index + 1 }} / {{ media.urls.length }}</span>
            }
        </div>
    }

    @if (store.isGenerating()) {
        <div class="generating-overlay">
            <ra-chat-orb [size]="64" [pulse]="true" />
            <strong>{{ 'iaChat.generating' | translate }}</strong>
        </div>
    }

    @if (store.showFavoriteFields()) {
        <div class="modal-backdrop" (click)="store.showFavoriteFields.set(false)">
            <div class="sheet" (click)="$event.stopPropagation()">
                <h3>{{ 'iaChat.favoriteFields' | translate }}</h3>
                @for (field of store.favoriteFields(); track field._id || field.id) {
                    <button type="button" (click)="store.insertFavoriteField(field)">{{ field.description }}</button>
                } @empty {
                    <p>{{ 'iaChat.noFavoriteFields' | translate }}</p>
                }
            </div>
        </div>
    }

    @if (store.showServiceResolver()) {
        <div class="modal-backdrop" (click)="store.showServiceResolver.set(false)">
            <div class="sheet resolver-sheet" (click)="$event.stopPropagation()">
                <header class="resolver-sheet__header">
                    <h3>{{ 'iaChat.whereToSave' | translate }}</h3>
                    <button
                        class="icon-button"
                        type="button"
                        (click)="store.showServiceResolver.set(false)"
                        [attr.aria-label]="'common.close' | translate">
                        <ra-icon icon="close-square" varColor="contentSecondary" [size]="20" />
                    </button>
                </header>

                <!-- Documento AVULSO: sem serviço nem cliente (order pessoal no backend).
                     Só aparece se a home souber listar avulsos. -->
                @if (homeListsStandalone()) {
                    <button type="button" class="resolver-option standalone" (click)="store.concludeWithOrder(null)">
                        <span class="resolver-option__icon">
                            <ra-icon icon="document-normal" varColor="accentGreen" [size]="18" />
                        </span>
                        <span class="resolver-option__content">
                            <strong>{{ 'iaChat.standaloneOption' | translate }}</strong>
                            <span>{{ 'iaChat.standaloneOptionSubtitle' | translate }}</span>
                        </span>
                        <span class="resolver-option__chevron" aria-hidden="true"></span>
                    </button>
                }
                <!-- Criar um serviço na hora, sem perder a conversa -->
                <button type="button" class="resolver-option create" (click)="showCreateOrder.set(true)">
                    <span class="resolver-option__icon">
                        <ra-icon icon="add" varColor="primary" [size]="18" />
                    </span>
                    <span class="resolver-option__content">
                        <strong>{{ 'iaChat.createNewService' | translate }}</strong>
                    </span>
                    <span class="resolver-option__chevron" aria-hidden="true"></span>
                </button>

                <div class="resolver-sheet__divider">
                    <span>{{ 'iaChat.servicesInProgress' | translate }}</span>
                </div>

                @if (store.loadingOrders()) {
                    <p class="resolver-sheet__hint">{{ 'common.loading' | translate }}</p>
                } @else {
                    <div class="resolver-sheet__orders">
                        @for (order of store.orders(); track order._id) {
                            <button type="button" class="resolver-option order" (click)="store.concludeWithOrder(order._id)">
                                <span class="resolver-option__icon">
                                    <ra-icon icon="folder" varColor="contentSecondary" [size]="18" />
                                </span>
                                <span class="resolver-option__content">
                                    <strong>{{ order.description || order.client?.name || ('iaChat.serviceFallback' | translate) }}</strong>
                                    @if (order.code) { <span>#{{ order.code }}</span> }
                                </span>
                                <span class="resolver-option__chevron" aria-hidden="true"></span>
                            </button>
                        } @empty {
                            <p class="resolver-sheet__hint">{{ 'iaChat.noServiceInProgress' | translate }}</p>
                        }
                    </div>
                }
            </div>
        </div>
    }

    @if (showCreateOrder()) {
        <order-create (close)="showCreateOrder.set(false)" (created)="onServiceCreated($event)" />
    }
</section>

@if (store.showAttachMenu()) {
    <div class="attach-menu">
        <!-- Um item só para mídia: aceita fotos E vídeos, vários de uma vez.
             Quem decide se vira card de imagem ou grupo no documento é a IA. -->
        <label class="attach-menu__item">
            <span class="attach-menu__left">
                <ra-square-icon icon="gallery" [interactive]="false" />
                <p>{{ 'iaChat.attachMedia' | translate }}</p>
            </span>
            <ra-icon icon="arrow-right" varColor="currentColor" [size]="20" />
            <input type="file" accept="image/*,video/*" multiple hidden (change)="onFilesSelected($event)" />
        </label>
        <button class="attach-menu__item" type="button" (click)="openFavoriteFields()">
            <span class="attach-menu__left">
                <ra-square-icon icon="star" [interactive]="false" />
                <p>{{ 'iaChat.favoriteFields' | translate }}</p>
            </span>
            <ra-icon icon="arrow-right" varColor="currentColor" [size]="20" />
        </button>
    </div>
}
</div>
</div>
